<template>
  <topbar
    :titulo="$t('RH.PESSOAS')"
    :subtitulo="$t('RH.PESSOAS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-4">
        <div></div>
        <b-button
          @click="cadastrar"
          variant="info"
          class="mf-2"
          v-if="podeCadastrar"
        >
          {{ $t('GERAL.CADASTRAR') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
<script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('RH.RECURSOS_HUMANOS') },
        { titulo: this.$t('RH.PESSOAS') },
      ],
    };
  },
  methods: {
    // FUNÇÕES AUXILIARES:
    cadastrar() {
      this.$router.push({ name: 'nova-pessoa' });
    },
  },
};
</script>
